/**
 * @fileoverview PUT handler for the "/comments/:target/global_notification_setting" endpoint
 */
import fetch from "@lib/fetch";

import type { AppendAppGroupToUrl } from "../comments/types";
import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { commentsTargetGlobalNotificationSettingCacheKeys } from "./constants";
import type { PutCommentsTargetGlobalNotificationSettingProps } from "./types";

export const putCommentsTargetGlobalNotificationSetting = reactQueryMutationAdapter(
  commentsTargetGlobalNotificationSettingCacheKeys,
  ({ appGroupId, ...props }: AppendAppGroupToUrl<PutCommentsTargetGlobalNotificationSettingProps>): Promise<{}> => {
    return fetch(`/comments/${props.target}/global_notification_setting?app_group_id=${appGroupId}`, "PUT", props);
  }
);
